import { render, staticRenderFns } from "./SelectedMembers.vue?vue&type=template&id=ed16d356&scoped=true"
import script from "./SelectedMembers.vue?vue&type=script&lang=js"
export * from "./SelectedMembers.vue?vue&type=script&lang=js"
import style0 from "./SelectedMembers.vue?vue&type=style&index=0&id=ed16d356&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed16d356",
  null
  
)

export default component.exports